import { Button, Input, Select } from "@ui";
import style from "./ControlPanel.module.scss";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { setActiveFilter, setActiveSearchIdParameter, setApplytTo } from "@global-state/pages/admin/customers/slice";
import cn from "classnames";
import { AbsoluteBlock } from "UI/shared";
import { ProxySettings } from "./components/ProxySettings/ProxySettings";
import { useEffect, useState } from "react";

const listSelectValues = [
    {
        label: "Тільки вибрані",
        value: "selected"
    },
    {
        label: "Усі користувачі",
        value: "all"
    },
    {
        label: "Тільки активні",
        value: "active"
    },
    {
        label: "Тільки неактивні",
        value: "notActive"
    }
]


export function ControlPanel() {
    const { activeFilter, activeSearchIdParameter } = useAppSelector(state => state.customersAdminPage)
    const [activeSelect, setActiveSelect] = useState({
        label: "Тільки вибрані",
        value: "selected"
    })

    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(setApplytTo(activeSelect.value as "notActive" | "active" | "all" | "selected"))
    }, [activeSelect])

    return (
        <div className={style.container}>
            <div className={cn(style.box, " max-sm:flex-col max-sm:w-full")}>
                <div className={style.filter}>
                    <button
                        className={activeFilter === "all" ? style.active : ""}
                        onClick={() => {
                            dispatch(setActiveFilter("all"));
                        }}
                    >
                        Усі
                    </button>
                    <button
                        className={activeFilter === "active" ? style.active : ""}
                        onClick={() => {
                            dispatch(setActiveFilter("active"));
                        }}
                    >
                        Активні
                    </button>
                </div>
                <div className={style.search}>
                    <Input
                        value={activeSearchIdParameter}
                        type="search"
                        label="Пошук за id"
                        customStyle={{
                            width: "!w-full !max-w-full"
                        }}
                        onChange={(value) => {
                            dispatch(setActiveSearchIdParameter(value.replace(/\D/g, "")));
                        }}
                    />
                </div>
            </div>
            <div className={style.box}>
                <div>
                    <p className="text-[12px]">Застосувати до:</p>
                    <Select
                        currentValue={activeSelect}
                        listValues={listSelectValues}
                        onChange={(value) => {
                            setActiveSelect(value)
                        }}
                    />
                </div>
                <AbsoluteBlock
                    XAlign="left"
                    advancedAdaptive
                    targetElement={
                        <Button
                            color="blue"
                            form="rectangle"
                            text="Редагувати"
                            customStyle={{
                                button: "!h-[42px] !px-[50px]",
                                text: "!text-[15px]"
                            }}
                        />
                    }
                    content={(isOpen) => <ProxySettings isOpen={isOpen} funds term />}
                />
            </div>
        </div>
    )
}

